import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {LoadingController, NavController} from '@ionic/angular';
import {ApiService} from '../../../services/api.service';
import {Storage} from '@ionic/storage';
import {ToastService} from '../../../services/toast.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.page.html',
  styleUrls: ['./signup.page.scss'],
})
export class SignupPage implements OnInit {
  signupForm: FormGroup;
  step = 0;
  qrcode: any;

  constructor(private navController: NavController, public route: ActivatedRoute, private apiService: ApiService , private storage: Storage, private loadingController: LoadingController, private toastService: ToastService) { }

  ngOnInit() {
    this.apiService.authApi.setToken(null);
    this.qrcode = this.route.snapshot.paramMap.get('qrcode');

    this.signupForm = new FormGroup({
      email: new FormControl('', Validators.compose([Validators.required, Validators.minLength(3), Validators.email])),
      validation: new FormControl('', Validators.compose([Validators.required])),
      password: new FormControl('', Validators.compose([Validators.required, Validators.minLength(6)])),

      firstName: new FormControl('', Validators.compose([Validators.required, Validators.minLength(3)])),
      lastName: new FormControl('', Validators.compose([Validators.required, Validators.minLength(3)])),
      telephone: new FormControl('', Validators.compose([Validators.required, Validators.pattern('^(\\+|[0-9])[0-9]*$')])),

      addresse: new FormControl(''),
      codePostal: new FormControl('', Validators.compose([Validators.pattern('^[0-9]{5,6}$')])),
      ville: new FormControl(''),
      pays: new FormControl(''),
    });

  }

  nextStep(){
    this.step = this.step + 1;
  }

  goTo(uri){
    this.navController.navigateForward('/' + this.qrcode + uri);
  }

  back(){
    this.navController.navigateBack('/' + this.qrcode);
  }


  async sendMail(){
    const loading = await this.loadingController.create({
      spinner: 'circular'
    });

    loading.present();

    this.apiService.authApi.postRegisterMail({
      email: this.signupForm.controls.email.value
    }).then((e: any) => {
      loading.dismiss();
      this.nextStep();
    }).catch(() => {
      this.toastService.error('Envoie d\'email de confirmation impossible. Avez-vous déjà un compte ?');
      loading.dismiss();
    });
  }

  async checkCode(){
    const loading = await this.loadingController.create({
      spinner: 'circular'
    });

    loading.present();

    this.apiService.authApi.postRegisterCode({
      email: this.signupForm.controls.email.value,
      code: this.signupForm.controls.validation.value
    }).then((e: any) => {
      loading.dismiss();
      this.nextStep();
    }).catch(() => {
      this.toastService.error('Code de validation erroné.');
      loading.dismiss();
    });
  }

  async doAction() {
    if (this.signupForm.invalid) { return; }

    const loading = await this.loadingController.create({
      spinner: 'circular'
    });

    loading.present();

    this.apiService.authApi.postRegister({
      email : this.signupForm.controls.email.value,
      firstname : this.signupForm.controls.firstName.value,
      name : this.signupForm.controls.lastName.value,
      address : this.signupForm.controls.addresse.value,
      postal_code : this.signupForm.controls.codePostal.value,
      city : this.signupForm.controls.ville.value,
      country : this.signupForm.controls.pays.value,
      password : this.signupForm.controls.password.value,
      password_confirmed : this.signupForm.controls.password.value,
      phone_number1 : this.signupForm.controls.telephone.value,
      status : '0'
    }).then((e: any) => {
      this.apiService.authApi.postLogin(this.signupForm.controls.email.value, this.signupForm.controls.password.value).then((e: any) => {
        loading.dismiss();

        this.apiService.authApi.setToken(e.access_token).then((e) => {
          this.navController.navigateForward('/' + this.qrcode + '/edit');
        });
      }).catch(() => {
        this.apiService.authApi.setToken(null);
        loading.dismiss();
        this.navController.navigateForward('/' + this.qrcode + '/edit/login');
      });
    }).catch(() => {
      this.toastService.error('Création du compte distributeur impossible. Vérifiez les informations saisies');
      loading.dismiss();
    });
  }
}
